import { defineStore } from 'pinia';
import { ref, watch } from 'vue';
import { RouteMeta, Route } from 'vue-router';

// INFO: Uses window.ROUTER object to allow access to router data inside of the store.
// NOTE: Avoid deep watching window.ROUTER as Route objects contain circular references
// that cause "Maximum call stack size exceeded" errors during Vue's _traverse.

const useRouterStore = defineStore('router', () => {
  const router = ref(window.ROUTER); // reactive wrapper for window.ROUTER object
  const to = ref<Route>(router.value?.to);
  const from = ref<Route>(router.value?.from);
  const meta = ref<RouteMeta>(router.value?.meta || {} as RouteMeta);
  const basePath = ref(router.value?.basePath);

  // Use a shallow comparison based on route path/name to avoid circular reference traversal
  // Instead of deep watching the entire Route objects, watch specific serializable properties
  watch(
    () => ({
      toPath: window.ROUTER?.to?.path,
      toName: window.ROUTER?.to?.name,
      fromPath: window.ROUTER?.from?.path,
      fromName: window.ROUTER?.from?.name,
      basePath: window.ROUTER?.basePath,
    }),
    () => {
      to.value = window.ROUTER?.to;
      from.value = window.ROUTER?.from;
      meta.value = window.ROUTER?.meta;
      basePath.value = window.ROUTER?.basePath;
    },
  );

  return {
    to,
    from,
    meta,
    basePath,
  };
});

export default useRouterStore;
